module.exports = __webpack_public_path__ + "static/media/bg-2.4666fb78.png";